import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './CKYC.css';
import DocTypeUpload from "./DocTypeUpload";
import UploadDoc from "./UploadDoc";
import VeryficationCKYC from "./VeryficationCKYC";
import MaskedInput from "react-text-mask";
import { baseUrl } from "../index";
import VLoader from "../components/Loader";

const CKYCHome = (props) => {
    
    //const history = useHistory();
    let navigate = useNavigate();
    const [step, setStep] = useState("");
    const [DocType, setDoctype] = useState("PAN");
    const [DocID, setDocID] = useState("");
    const [UniqueID, setUniqueID] = useState("");
    const [Text, setText] = useState("");
    const [RedirectURL, setRedirect] = useState("");
    const [Error, setError] = useState("");
    const [KycDetails, setKYCDetails] = useState("");
    const [IsKYCDetailsFilled, setKycDetailsFilled] = useState(false);
    const [BtnText, setBTNText] = useState("Submit");
    const [AddressDetails, setAddressDetails] = useState({});
    const [isLoader, setLoader] = useState(false);
    //console.log("test", props.KYCDetails);
    useEffect(() => {
        let doctype = props.CKYCData.find(row => row.name.match(props.KYCDetails.DocType)) || null
        // console.log(DocID);

        if (props.KYCErrorMsg !== "" || props.KYCErrorMsg !== null) {
            setError(props.KYCErrorMsg);
        }
        setDocID(props.KYCDetails?.DocNumber ?? "");
        console.log('test', props.CKYCData, props.KYCDetails, doctype, props.CKYCData.find(row => row.name.match(props.KYCDetails.DocType)));
        if (props.IsProposalKYC) {
            setDoctype(doctype?.name);
            setRedirect(props.Redirection);
            setStep(props.step);
            if (props.step === "") {
                setDoctype(doctype?.name);
            }
            setKycDetailsFilled(true);
        } else {
            setDoctype(doctype?.name);
        }
        setAddressDetails(props.KYCDetails.AddressDetails);
    }, []);

    useEffect(() => {
        if (IsKYCDetailsFilled)
            submitForm(KycDetails.IsUploadFile, KycDetails.IsRedirectUrl,);
    }, [IsKYCDetailsFilled])
    useEffect(() => {
        setText(`Enter ${DocType}`);
    }, [DocType]);

    const submitForm = (IsFileUploaded, IsRedirectUrl) => {
        
        setLoader(true);
        setStep("");
        if (DocType !== "select" && DocID.trim() !== "") {
            setError('');
            setBTNText("Please Wait...");
            const dcType = DocType?.toLowerCase().match("pan") ? "PAN" : DocType?.toLowerCase().match("adha") ? "AADHAAR" : "";
            if (checkDoc(dcType, DocID)) {
                let doctype = '';
                if (props.KYCDetails.FromHealth) {
                    doctype = props.CKYCData.filter(row => row.name === DocType)[0]?.companyValue;
                } else {
                    doctype = props.CKYCData.find(row => row.name.match(props.KYCDetails.DocType))?.code;
                }
                let NomineeDetails = props.KYCDetails.nomineeDetails;
                if (props.CompanyID === 118) {
                    const rel = KycDetails?.Relation?.split("~");
                    NomineeDetails.RelationShip = rel?.length > 0 ? rel[1] : "";
                    NomineeDetails.Name = rel?.length > 0 ? rel[0] : "";;
                }
                const ckycmodel = {
                    EnquiryNo: props.KYCDetails.EnquiryNo,
                    InsurerID: props.KYCDetails.CompanyID,
                    DocType: doctype,
                    DocNumber: DocID,
                    UniqueID: UniqueID,
                    DOB: props.KYCDetails.DOB,
                    Name: props.KYCDetails.Name,
                    Gender: props.KYCDetails.Gender === "Female" ? "F" : "M",
                    MobileNo: props.KYCDetails.Mobile,
                    EmailID: props.KYCDetails.Email,
                    PinCode: props.KYCDetails.PinCode,
                    TypeOfMotor: parseInt(props.KYCDetails.Type),
                    TypeOfPolicy: parseInt(props.KYCDetails.TypeOfPolicy),
                    IsCorporate: props.KYCDetails.IsCorporate,
                    OdOnly: props.KYCDetails.PolicyType === "2",
                    ThirdPartyCover: props.KYCDetails.PolicyType === "1",
                    ProductType: props.KYCDetails.ProductType,
                    IsFileUploaded,
                    IsRedirectUrl,
                    FromHealth: props.KYCDetails.FromHealth == true,
                    SelectedPOA: IsFileUploaded ? KycDetails.SelectedPOA : "",
                    SelectedPOI: IsFileUploaded ? KycDetails.SelectedPOI : "",
                    SelectedPOAValue: IsFileUploaded ? KycDetails.selectedPOAValue : "",
                    SelectedPOIValue: IsFileUploaded ? KycDetails.SelectedPOIValue : "",
                    nomineeDetails: NomineeDetails,
                    AddressDetails: {
                        CPinCode: AddressDetails.PinCode,
                        CState: AddressDetails.StateName,
                        CCity: AddressDetails.CityName,
                        CDistrict: AddressDetails.CityName,
                        CAddressLine1: AddressDetails.AddressLine1,
                        CAddressLine2: AddressDetails.AddressLine2,
                        CAddressLine3: AddressDetails.AddressLine3,
                        PAddressLine1: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine1 : AddressDetails.AddressLine1,
                        PAddressLine2: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine2 : AddressDetails.AddressLine2,
                        PAddressLine3: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine3 : AddressDetails.AddressLine3,
                        PCity: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName,
                        PPinCode: AddressDetails.IsChangeAddress ? AddressDetails.PerPinCode : AddressDetails.PinCode,
                        PState: AddressDetails.IsChangeAddress ? AddressDetails.PerStateName : AddressDetails.StateName,
                        PDistrict: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName
                    }
                }
                //
                
                axios.post(`${baseUrl}/services/call`, { URL: "/CheckCkycStatus", PostString: JSON.stringify(ckycmodel) })
                    .then(Res => {
                        setLoader(false);
                        //console.log(Res.data);
                        const Response = Res.data.Response;
                        if (Res.data.StatusCode === 200 ) {
                            if (Response.CKYCStatus) { 
                                //submitKYCDetails(1, '10064156580849', 'SMCENQ25002143', Res.data.TransKey);
                                submitKYCDetails(Response.CKYCStatus, Response.CKYCID, Response.CKYCRefID, Res.data.TransKey);
                                alert("KYC Details Fetched Successfully");
                            }
                        } else if (Res.data.StatusCode === 480) {
                            if (Response.IsUploadFile)
                                setStep((Response.UploadFileType === "poi,poa" || Response.UploadFileType === "poa,poi" || Response.UploadFileType === "poi" || Response.UploadFileType === "poa") ? "UploadDoc" : "UploadDocForm60");
                            else if (Response.Redirecturl) {
                                setRedirect(Response.RedirectLink);
                                setUniqueID(Response.CKYCRefID);
                                setStep("Redirection");

                            }
                            else setError(Response.ErrMsg);
                            setKycDetailsFilled(false);
                        }
                        setBTNText("Submit");
                    })
                    .catch(err => {
                        setLoader(false);
                        setBTNText("Submit");
                        setError(err.message)
                    })

            } else {
                setLoader(false);
                setError(`Invalid ${DocType} ID`);
            }
        } else {
            setLoader(false);
            setError(`${(DocType === "select" && DocID.trim() !== "") ? "Select document Type" : (DocType !== "select" && DocID.trim() === "") ? "Enter Document ID" : "Enter Valid Details"}`);
        }
    }
    const checkDoc = (caseV, value) => {
        let Pattern = "";
        let result = false;
        switch (caseV.toUpperCase()) {
            case "PAN":
                Pattern = /([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}$/;
                result = Pattern.test(value);
                break;
            case "AADHAAR":
                Pattern = /[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
                result = Pattern.test(value);
            default:
                result = true;
        }
        return result
    }

    const submitKYCDetails = (CKYCStatus, CKYCID, CKYCRefID, KycTransKey) => {
        const dcType = DocType?.toLowerCase().match("pan") ? "PAN" : DocType?.toLowerCase().match("adha") ? "AADHAAR" : "";
        if (checkDoc(dcType, DocID)) {

            let doctype = '';
            if (props.KYCDetails.FromHealth) {
                doctype = props.CKYCData.filter(row => row.name === DocType)[0]?.companyValue;
            } else {
                doctype = props.CKYCData.filter(row => row.name === DocType)[0]?.code;
            }

            const kycModel = {
                "DocType": doctype,
                "DocNumber": DocID,
                Base64Photo: "", //KycDetails.Base64Photo,
                Base64POI: "", //KycDetails.Base64POI,
                Base64POA: "", //KycDetails.Base64POA,
                isFileUploaded: KycDetails.isFileUploaded,
                SelectedPOA: KycDetails.SelectedPOA,
                SelectedPOI: KycDetails.SelectedPOI,
                SelectedPOIValue: KycDetails.SelectedPOIValue,
                selectedPOAValue: KycDetails.selectedPOAValue,
                CKYCStatus,
                CKYCID,
                CKYCRefID,
                KycTransKey,
                FromHealth: props.KYCDetails.FromHealth
            }
          
            props.onKycSubmit(kycModel);
        } else setError(`Invalid ${DocType} ID`);
    }

    console.log({step})

    return <>

        {isLoader && (<VLoader />)}  
        { 
            step === "Redirection" ? <VeryficationCKYC onKYCSubmit={(data) => submitForm(data.IsUploadFile, data.IsRedirectUrl)} setKYCDetails={(data) => setKYCDetails(data)} CKYCData={props.CKYCData} URL={RedirectURL} EnquiryNo={props.EnquiryNo} DocID={DocID} Companyid={props.CompanyID} closeKYC={props.closeKYC} /> :
                step === "UploadDocForm60" ? <UploadDoc title="form60" closeKYC={props.closeKYC} setKYCDetails={(data) => {
                    setKYCDetails(data);
                    setKycDetailsFilled(true);
                }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> :
                    step === "UploadPhoto" ? <UploadDoc title="photo" onKYCSubmit={props.closeKYC} setKYCDetails={(data) => {
                        setKYCDetails(data);
                        setKycDetailsFilled(true);
                    }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> :
                        step === "UploadDoc" ? <DocTypeUpload onKYCSubmit={props.closeKYC} setKYCDetails={(data) => {
                            //console.log("doc uploaded")
                            setKYCDetails(data);
                            setKycDetailsFilled(true);
                        }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> : <>
                        </>
        }


    </>
}
export default CKYCHome;